/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { Injectable } from '@angular/core';
import { LogService } from '../../';
import { TabContainerComponent } from '../../../components';

@Injectable()
export class TabService {
    /**
     * List of tabs
     * @private
     */
    private tabContainers: TabContainerComponent[] = [];

    /**
     * Stored active tab for setter/getter
     * @private
     */
    private _activeTabId: string;

    constructor(
        private log: LogService
    ) {
    }

    set activeTabId(id: string) {
        this._activeTabId = id;
    }

    get activeTabId(): string {
        return this._activeTabId;
    }

    /**
     * Adds a new instance of the tab component to our array of tabs
     * @param {TabContainerComponent} tabContainer
     */
    public add(tabContainer: TabContainerComponent): void {
        const tabCont: any = this.findContainer(tabContainer.id);

        if (!tabContainer.id && tabContainer.id !== '') {
            this.log.warn('tabContainers:Add()', 'Unable to add tab container as ID is missing.', tabContainer.id);

            return;
        }

        if (tabCont) {
            this.tabContainers.splice(this.tabContainers.indexOf(tabCont));
        }

        this.tabContainers.push(tabContainer);
    }

    /**
     * Function is used to find a modal within our array by its ID
     * @param id
     */
    public findContainer(id: string): any {
        for (const container of this.tabContainers) {
            if (container && container.id === id) {
                return container;
            }
        }
    }
}
